module.exports = __webpack_public_path__ + "static/media/carrossel-comentario-usuario-3.b52220ab.png";